export const state = () => ({
    books: [],
    selectedBook: [],
    booksLoading: false,
});
